import * as types from './actionTypes';
import {api} from '../utility';
import store from 'store';
import * as userActions from './authenticationActions';
import get from "lodash/get";
import sortBy from "lodash/sortBy";
import isEmpty from "lodash/isEmpty";
import isFunction from "lodash/isFunction";

export function setBriefsLoading(isLoading){
  return {type: types.SET_BRIEFS_LOADING, isLoading};
}

export function getBriefsSucess(briefs) {
  return { type: types.BRIEFS_SUCCESS, briefs};
}

export function setActiveBrief(activeBrief) {
  return { type: types.SET_ACTIVE_BRIEF, activeBrief};
}

export function getBriefs(){
  let token = store.get('topicToken');
  return function (dispatch, getState) {
    return fetch(api.GET_BASE_URL('TOPIC_BASE_URL') + api.GET_BRIEFS, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      if(data.error){
        throw data.error.message;
      }
      return dispatch(getBriefsSucess(data));
    })
    .catch(function(error) {
      throw error;
    });
  };
}

export function getAdthriveBriefs(){
  let adthriveAuthObj = store.get('adthriveAuthObj');
  let token = adthriveAuthObj && adthriveAuthObj.token;
  return function (dispatch, getState) {
    dispatch(setBriefsLoading(true));
    return fetch(api.GET_BASE_URL('ADTHRIVE_API_BASE_URL') + api.ADTHRIVE_GET_BRIEFS(getState().auth.activeSite.id), {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
      },
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      if(data.errors){
        throw data.errors;
      }
      try{
        data.data =  sortBy(data.data, (brief) => {
          return new Date(brief.createdAt).getTime() * -1;
        });
        return dispatch(getBriefsSucess(data));
      } catch(e){
        return dispatch(getBriefsSucess(data));
      }
    })
    .catch(function(errors) {
      // if there are any errors getting briefs, log the user out
      dispatch(userActions.logoutUser());
      return errors;
    });
  };
}

export function getActiveBrief(briefId){
  return function (dispatch, getState){
    return fetch(api.GET_BASE_URL('TOPIC_BASE_URL')+api.GET_BRIEFS+`${briefId}`, {
        method: 'GET'
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
        console.log(data);
        data.report.recommended_topics = data.report.recommended_topics.map((topic) => {
          topic.covered = false;
          return topic;
        });
        var newActiveBrief = Object.assign({}, getState().briefs.activeBrief, data);
        return dispatch(setActiveBrief(newActiveBrief));
    }).catch((err) =>{
        console.log(err);
    });
  }
}

export function updateActiveBriefContent(briefId, content){
  return function (dispatch, getState){
    fetch(api.GET_BASE_URL('TOPIC_BASE_URL')+api.GET_BRIEFS+`${briefId}`, {
        method: 'PUT',
        headers: {
          'content-type': 'application/json'
        },
        body: JSON.stringify({editor_content_gdocs:content.toString()})
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
        console.log(data);
        var newActiveBrief = Object.assign({}, getState().briefs.activeBrief);
        if(!isEmpty(newActiveBrief)){
          newActiveBrief.report.recommended_topics = newActiveBrief.report.recommended_topics.map((topic) => {
            topic.num_occurences_in_content = get(data.report.content_gdocs.covered_topics, topic.name, 0)
            topic.covered = topic.num_occurences_in_content ? true : false;
            return topic;
          });
          newActiveBrief.content_gdocs = data.report.content_gdocs;
        }
        return dispatch(setActiveBrief(newActiveBrief));
    }).catch((err) =>{
        console.log(err);
    });
  }
}

export function createAdthriveBrief({keyword, url}){
  let adthriveAuthObj = store.get('adthriveAuthObj');
  let token = adthriveAuthObj && adthriveAuthObj.token;
  return function (dispatch, getState) {
    dispatch(setBriefsLoading(true));
    let payload;
    if(!isEmpty(url)){
      payload = {
        keyword: keyword,
        type: 'Updated',
        url: url
      }
    } else{
      payload = {
        keyword: keyword,
        type: 'New'
      }
    }
    return fetch(api.GET_BASE_URL('ADTHRIVE_API_BASE_URL') + api.ADTHRIVE_GET_BRIEFS(getState().auth.activeSite.id), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body:JSON.stringify(payload)
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      if(data.errors){
        throw data.errors;
      }
      return dispatch(getAdthriveBriefs());
    })
    .catch(function(error) {
      throw error;
    });
  };
}

export function markAdthriveBriefComplete({briefId, completedAt, permalink, callback}){
  let adthriveAuthObj = store.get('adthriveAuthObj');
  let token = adthriveAuthObj && adthriveAuthObj.token;

  return function (dispatch, getState){
    return fetch(api.GET_BASE_URL('ADTHRIVE_API_BASE_URL') + api.ADTHRIVE_MARK_BRIEF_COMPLETE(getState().auth.activeSite.id, briefId), {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        "Content-Type": "application/json"
      },
      body:JSON.stringify({
        publishDate: completedAt, 
        id: briefId,
        status: "COMPLETED",
        url: permalink
      })
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      if(data.error){
        throw data.error.message;
      } else if(isFunction(callback)){
        callback(data);
      }
    })
    .catch(function(error) {
      throw error;
    });
  };
}

export function getBriefQuestionsStatus(briefId, successCallback){
  return function (dispatch, getState) {
    return fetch(api.GET_BASE_URL('TOPIC_BASE_URL') + api.GET_BRIEFS+api.ASYNC_QUESTIONS_STATUS+`${briefId}`, {
      method: 'GET',
    }).then(function(response) {
        return response.json();
    })
    .then(function(data) {
      try{
        if(data.status == "Success"){
          if(isFunction(successCallback)){
            successCallback();
          }
        }
      } catch(e){
        return dispatch(getActiveBrief(briefId));
      }
    })
    .catch(function(error) {
      throw error;
    });
  };
}